import * as React from "react";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import { Fragment } from "react";
import Stack from "@mui/material/Stack";
import { conditionIconMap } from "../Data/conditionIconMap";
import { conditionIconMapNight } from "../Data/conditionIconMapNight";
import UserGreeting from "./UserGreeting";

const date = new Date(Date.now());
let weekdayLong = date.toLocaleDateString("en-US", { weekday: "long" });
let dayNumber = date.toLocaleDateString("en-US", { day: "numeric" });
let monthLong = date.toLocaleDateString("en-US", { month: "long" });

const conditionIconMapArray = [conditionIconMapNight, conditionIconMap];

export default function WeatherWidget({
	inputTime,
	currentTimeOfDay,
	name,
	userName,
	setDialogForecastData,
	zipCode,
	setTimeZoneId,
}) {
	const [weatherData, setWeatherData] = useState([]);
	const [forecastData, setForecastData] = useState([]);
	const [currentDayForecast, setCurrentDayForecast] = useState([]);

	const [iconURL, setIconURL] = useState();
	const [backgroundID, setBackgroundID] = useState("");

	let userZipCode;
	if (localStorage.getItem("zipCode")) {
		userZipCode = localStorage.getItem("zipCode");
	} else {
		userZipCode = zipCode;
	}

	// let userIpAddress = userIp;
	// `${userIpAddress}`;

	const weatherUrl =
		"https://api.weatherapi.com/v1/forecast.json?key=637a4c8540044fcab43161639231903&days=6&aqi=no&alerts=no&hour=12&q=" +
		`${userZipCode}`;

	useEffect(() => {
		const dataFetch = async () => {
			const result = (await Promise.all([fetch(weatherUrl)])).map((r) =>
				r.json()
			);
			const [weatherResult] = await Promise.all(result);

			setWeatherData({
				cityName: weatherResult.location.name,
				region: weatherResult.location.region,
				timezone: weatherResult.location.tz_id,
				localEpoch: weatherResult.location.localtime_epoch,
				localTime: weatherResult.location.localtime,
				currentTemp: weatherResult.current.temp_f,
				currentWeather: weatherResult.current.condition.text,
				currentWeatherCode: weatherResult.current.condition.code,
				currentDayOrNight: weatherResult.current.is_day,
			});

			setCurrentDayForecast(weatherResult.forecast.forecastday[0]);
			const weatherArray = weatherResult.forecast.forecastday;

			setForecastData(weatherArray);

			setDialogForecastData(weatherResult.location);
			setTimeZoneId(weatherResult.location.tz_id);

			setIconURL("https:" + weatherResult.current.condition.icon);
			setBackgroundID(
				conditionIconMapArray[weatherResult.current.is_day][
					weatherResult.current.condition.code
				]
			);
		};

		dataFetch();
	}, [setDialogForecastData, setTimeZoneId, weatherUrl]);

	return (
		<Fragment>
			<Grid
				id={`${backgroundID}-background`}
				justifyContent="center"
				display="flex"
				flexDirection="column"
				className="grid-item"
				alignItems="stretch"
				xs={12}
				p={2}>
				<Grid container alignItems="flex-start">
					<Grid xs display="flex" justifyContent="flex-start">
						<UserGreeting
							currentTimeOfDay={currentTimeOfDay}
							name={name}
							userName={userName}
						/>
					</Grid>
					<Grid xs="true" display="flex" justifyContent="flex-end">
						<Stack direction="column" alignItems="flex-end">
							<Typography variant="h5" fontWeight="600">
								{inputTime}
							</Typography>
							<Typography
								variant="subtitle2"
								color="rgba(255,255,255,.8)"
								fontWeight={300}>
								{weekdayLong}&nbsp;
								{monthLong}&nbsp;
								{dayNumber}
							</Typography>
						</Stack>
					</Grid>
				</Grid>
				<Grid container alignItems="center">
					<Grid xs={12}>
						<>
							{forecastData && currentDayForecast && currentDayForecast.day && (
								<Stack alignItems="flex-start" fontSize="1rem">
									<Typography
										display="block"
										color="white"
										variant="h2"
										fontWeight="400"
										className="grid-testing">
										{Math.round(weatherData.currentTemp)}
										<sup style={{ verticalAlign: "super", fontSize: ".5em" }}>
											&#176;
										</sup>
									</Typography>
								</Stack>
							)}
						</>
					</Grid>
				</Grid>
				<Grid container alignItems="center">
					<Grid xs={4}>
						<Stack direction="row" alignItems="center">
							<img width="32px" alt="weather icon" src={iconURL} />
							<Typography
								textAlign="left"
								variant="body1"
								fontWeight="500"
								className="grid-testing">
								{weatherData.currentWeather}
							</Typography>
						</Stack>
					</Grid>
					<Grid xs={4}></Grid>

					<Grid xs={4} display="flex" justifyContent="flex-end">
						<Typography
							textAlign="right"
							variant="h6"
							fontWeight="400"
							mt={0.2}
							className="grid-testing">
							{weatherData && weatherData.cityName}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
}
